import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';

import * as CalculatorActions from './calculator.actions';
import { CalculatorService } from '../services/calculator-service';



@Injectable()
export class CalculatorEffects {

  estimatePension$ = createEffect(() => {
    return this.actions$.pipe( 
      ofType(CalculatorActions.estimatePension),
      mergeMap(action => {
        return this.calculatorService.estimatePension(action.values).pipe(
          map(estimate => CalculatorActions.estimatePensionSuccess({ data: estimate })),
          catchError(error => of(CalculatorActions.estimatePensionFailure({ error })))
        );
      })
    );
  });

  constructor(private actions$: Actions, private calculatorService: CalculatorService) { }
}